import * as React from 'react';
import * as PopoverPrimitive from '@radix-ui/react-popover';
import { cn } from '../../utils';
const Popover = PopoverPrimitive.Root;

const PopoverTrigger = PopoverPrimitive.Trigger;
const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & {
    container: HTMLElement;
    className?: string;
    align?: 'start' | 'center' | 'end';
    sideOffset?: number;
  }
>(
  (
    { className, align = 'start', sideOffset = 4, container, ...props },
    ref,
  ) => (
    <PopoverPrimitive.Portal container={container}>
      <PopoverPrimitive.Content
        ref={ref}
        align={align}
        sideOffset={sideOffset}
        className={cn(
          'lf:text-popover-foreground lf:shadow-md lf:data-[state=open]:animate-in lf:data-[state=closed]:animate-out lf:data-[state=closed]:fade-out-0 lf:data-[state=open]:fade-in-0 lf:data-[state=closed]:zoom-out-95 lf:data-[state=open]:zoom-in-95 lf:data-[side=bottom]:slide-in-from-top-2 lf:data-[side=left]:slide-in-from-right-2 lf:data-[side=right]:slide-in-from-left-2 lf:data-[side=top]:slide-in-from-bottom-2 lf:z-[9999] lf:w-72 lf:rounded-md lf:border lf:border-neutral-200 lf:bg-negative-500 lf:p-4 lf:outline-hidden',
          className,
        )}
        {...props}
      />
    </PopoverPrimitive.Portal>
  ),
);
PopoverContent.displayName = PopoverPrimitive.Content.displayName;
export { Popover, PopoverTrigger, PopoverContent };
